import React, { FC } from 'react';

//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';
import { rtkCallback } from 'utils/rtkCallback';

import { useDeleteRequestWorkMutation } from 'bus/request';

type DetailModalRoleProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
  const [deleteRequestWork, { reset, isLoading }] = useDeleteRequestWorkMutation();

  const responseSuccess = () => {
    props.refresh();
    props.changeVisible(false);
    reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    deleteRequestWork({ id: props.id! }).then((r) => rtkCallback(r, responseSuccess));
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить запись?</div>
            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => props.changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
